module.exports = __webpack_public_path__ + "img/oneGray.9a0f3531.png";